import { Component, HostBinding, OnInit, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import * as imagesLoaded from 'imagesloaded';
import { appConfig } from './../app.config';

@Component({
  selector: 'app-poster-image',
  templateUrl: './poster-image.component.html',
  styleUrls: ['./poster-image.component.scss'],
  host: {
    '[style.height.px]':'height',
    '[style.width.px]':'width'
  },
  animations: [
    trigger('fadeIn', [
      state('hidden', style({
        opacity: '0',
        visibility: 'hidden'
      })),
      state('visible',   style({
        opacity: '1',
        visibility: 'visible'
      })),
      transition('hidden => visible', animate('250ms ease-in'))
    ])
  ]
})
export class PosterImageComponent implements OnInit {
  @Input() itemId: number;
  @Input() title: string;
  @Input() image: any;
  @Input() imageRetina: any;
  @Input() height: number;
  @Input() width: number;
  @Input() isInitialised: boolean = false;
  @Output() onInitEvent = new EventEmitter();

  public imageSrcBase = appConfig.imageUrl;

  @HostBinding('@fadeIn') get fadeIn() { return this.isInitialised ? 'visible' : 'hidden'; };

  el: Element;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  ngOnInit() {
    if (!this.isInitialised) {
      imagesLoaded(this.el, ( instance, image ) => {
        this.isInitialised = true;
        this.onInitEvent.emit();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/poster-image/poster-image.component.ts